
import React from "react";
import {Tab, Tabs, TabList, TabPanel} from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ObjectAttributesHistory from '../../home/report/ObjectAttributeHistory';
import ObjectHistorys from '../../home/report/ObjectHistory';
import DocumentLinks from '../../home/report/ObjectDocumentLink';
import ProjectData from '../../home/report/ProjectData';
import Report from "../../home/report/Report";



const TabsAdds = ({selectedGlobalObjectKey,data,state,setSelectedGlobalObjectKey,selectedRow}) => {
    return (
        <Tabs
            className="tabs"
            selectedTabClassName="add-tab--selected"
            forceRenderTabPanel={true}
            >
                <TabList>
                    <Tab>Object Data</Tab>
                    <Tab>Attribute History</Tab>
                    <Tab>Object History</Tab>
                    <Tab>Linked Documents</Tab>
                    <Tab>Project Data</Tab>
                </TabList>
            <TabPanel>       
                    <Report
                        data={data}
                        state={state}
                        setSelectedGlobalObjectKey={setSelectedGlobalObjectKey}
                        selectedGlobalObjectKey={selectedGlobalObjectKey}
                    />                  
                </TabPanel>
                <TabPanel>                   
                    <ObjectAttributesHistory
                        selectedGlobalObjectKey={selectedGlobalObjectKey}                        
                        />
                </TabPanel>
                <TabPanel>   
                    <ObjectHistorys
                        selectedGlobalObjectKey={selectedGlobalObjectKey}
                    />                   
                </TabPanel>
                <TabPanel>   
                    <DocumentLinks
                        selectedGlobalObjectKey={selectedGlobalObjectKey}
                    />
                </TabPanel>
                <TabPanel>
                    <ProjectData
                        selectedGlobalObjectKey={selectedGlobalObjectKey}
                    />
                </TabPanel>
            </Tabs>
      
    );
}
export default TabsAdds